import {defineStore} from 'pinia';
import {ModuleAccount} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import accountAPI from '@/apis/di/accountAPI';

const accountStore = new BaseDictionaryStore(accountAPI);

export const useAccountStore = defineStore(ModuleAccount, {
  state: () => ({
    ...accountStore.state,
    _config: {
      key: 'account_id',
      table: 'di_account',
      moduleName: 'Tài khoản',
      quickFollow: 'active',
      code: 'account_number',
      name: 'account_name',
      isTree: true,
      defaultSort: 'account_number',
      // Không thực hiện log hành động thêm sửa xóa theo basedictionarylist, basedictionarydetail
      notLogByBase: true
    },
    moduleName: 'account',
  }),
  actions: {
    ...accountStore.action,
    /**
     * cập nhật phát sinh tài khoản
     * dvthuc 29/05/2023
     */
    async updateTranferAccountData(payload) {
      const res = await accountAPI.updateTranferAccountData(payload || {});
      return res;
    },

    /* Cập nhật dữ liệu khi chuyển danh mục (truyền vào list data)
    ntban - 4.7.2023
     */
    async updateTranferListData(payload) {
      const me = this;
      const res = await accountAPI.updateTranferListData(payload || {});
      if (res) {
        if (payload.State == 0) {
          // context.commit('insertItem', payload.ToData);
          if (res) {
            me.items = [payload.ToData, ...me.items];
          }
        } else if (payload.State == 1) {
          this.updateItem(payload.ToData);
        }
      }
      return res;
    },

    /**
     * Insert tài khoản 216, 218, 467 sau khi enable option 'Kế toán tài sản kết cấu hạ tầng giao thông thủy lợi' trong Nghiệp vụ/Nghiệp vụ khác
     * ndchien1 - 05/07/2023
     */
    async insertAccount() {
      const me = this;
      const res = await accountAPI.insertOtherBusiness();
      if (res) {
        me.loadFullCache({remoteVersion: Math.floor(Math.random() * 1000) + 2});
      }
      return res;
    },

    /**
     * Delete tài khoản 216, 218, 467 sau khi disable option 'Kế toán tài sản kết cấu hạ tầng giao thông thủy lợi' trong Nghiệp vụ/Nghiệp vụ khác
     * ndchien1 - 05/07/2023
     */
    async deleteOtherBusiness() {
      const me = this;
      const res = await accountAPI.deleteOtherBusiness();
      if (res) {
        me.loadFullCache({remoteVersion: Math.floor(Math.random() * 1000) + 2});
      }
      return res;
    },

    /**
     * Thực hiện cập nhật đầu 009
     * pdtai 11.09.2023
     */
    async updateAccount009() {
      const me = this;
      await me.loadFullCache({remoteVersion: Math.floor(Math.random() * 1000) + 2});
    },

    /**
     * Thực hiện check phát sinh tài khoản 009
     * pdtai 13.09.2023
     */
    async checkDataGeneration(payload) {
      const res = await accountAPI.checkDataGeneration(payload || {});
      return res;
    }
  },
  getters: {
    ...accountStore.getters,
  },
});
